
import Vue from 'vue'
import validate from 'mixins/validate'

Vue.component('contact-form', {
  mixins: [validate],
  methods: {
    submitForm (e) {
      const isValid = this.validateAndDisplayErrors(e)

      if (!isValid) {
        e.preventDefault()
      }
    }
  }
})
